/* eslint-disable indent */
/* eslint-disable no-console */
(function () {
	("use strict");
	window.mjpl.vto = window.mjpl.vto || {};
	window.mjpl.vto.styles = {};
	window.vto_i18n = window.vto_i18n || {
		switchToStyle: "Switch to style",
	};

	const vtoModal = document.querySelector("#vto-modal");
	// If no VTO modal is found, do nothing.
	if (!vtoModal) return;

	const swatchListContainer = document.querySelector("[data-vto-swatch-list]");
	const relatedStylesListContainer = document.querySelector(
		"[data-vto-related-styles-list]"
	);
	const skuNameDisplay = document.querySelector("[data-vto-sku-name-display]");
	const skuNameDisplayLens = document.querySelector(
		"[data-vto-sku-name-display-lens]"
	);
	const genderSelectionButtons = Array.from(
		document.querySelectorAll("[data-vto-gender]")
	);
	const consentSelectionButton = Array.from(
		document.querySelectorAll("[data-vto-consent-mj]")
	);
	const productNameElement = document.querySelector(
		".modal__vto-product .product-name"
	);
	const shopThisStyleLink = document.querySelector("[data-vto-shop-button]");
	const urlEndpointTemplate = window.mjpl.vto
		? mjpl.vto.dataRequestEndpoint
		: null;
	const changeFit = document.querySelector("[data-vto-change-fit]");
	const fittingBoxScript = document.createElement("script");
	const styleControls = document.querySelector("[data-vto-style-controls]");
	const vtoBox = document.querySelector(".modal__vto-video-wrapper");
	const vtoBoxHeading = document.querySelector(".modal__vto-video-heading");
	const vtoBoxProduct = document.querySelector(".modal__vto-product");
	const vtoBoxHeadingTerms = document.querySelector(
		".modal__vto-video-title-fitting-box"
	);
	const vtoMobileDrawer = document.querySelector(".vto-mobile-drawer-button");
	fittingBoxScript.setAttribute(
		"src",
		"//vto-advanced-integration-api.fittingbox.com/index.js"
	);
	fittingBoxScript.setAttribute("type", "text/javascript");
	document.body.appendChild(fittingBoxScript);
	fittingBoxScript.onload = () => {
		// Gender select is disabled until fittingBox script is loaded.
		genderSelectionButtons.map((button) => {
			button.addEventListener("click", genderSelectionEvent);
			button.removeAttribute("disabled");
		});
		consentSelectionButton.map((button) => {
			button.addEventListener("click", consentSelectionEvent);
		});
	};

	instantiateVtoTriggers();

	function instantiateVtoTriggers() {
		// Find uninstantiated VTO triggers.
		const vtoTriggers = Array.from(
			document.querySelectorAll(
				"[data-vto-product-code]:not([data-vto-trigger-instantiated])"
			)
		);
		// If no VTO triggers are found, do nothing.
		if (!vtoTriggers.length) return;
		vtoTriggers.forEach((trigger) => {
			trigger.addEventListener("click", openVtoModal);
			trigger.dataset.vtoTriggerInstantiated = true;
		});
	}

	function createFitMixInstance(sku = null, antiReflection = null) {
		const params = {
			// TODO: move API key to proper place.
			apiKey: "K7sJhnWYh3XPTc0HSViq1KpzXoAlhnlP2aYKgcfW",
			css: '[data-style="vto-adv-disclaimer"] {padding: 0 25px;display: flex;flex-direction: column;align-items: center;}[data-style="vto-adv-disclaimer-btn-container"]{@media (min-width: 768px) {flex-wrap: nowrap}}[data-style="vto-adv-disclaimer-container-text"] { height: 100%;overflow-y: scroll; border: 1px solid #B7B7B7;padding: 10px 10px 0 10px;color: #747474;max-width: 100%; } [data-style="vto-adv-disclaimer-btn-disagree"] { width: 50%;min-width: 300px; padding: 11px 36px 11px 36px;border-radius: 8px;border: 1px solid #1F1507;font-size: 16px; font-weight: 400;line-height: 19.2px;text-align: center;background: transparent} [data-style="vto-adv-disclaimer-btn-agree"] { width: 50%;min-width: 300px; padding: 11px 36px 11px 36px;border-radius: 8px;border: 1px solid #1F1507;font-size: 16px; font-weight: 400;line-height: 19.2px;text-align: center;background-color: #1F1507; color: #fff}[data-style="vto-adv-live-action-left"] {bottom: 4.5rem;}',
			onPrivacyTermsShown: () => {
				vtoBox.classList.add("change-height");
				vtoBoxProduct.classList.add("hide");
				vtoBoxHeadingTerms.classList.remove("hide");
				// vtoBoxHeading.classList.add("hide");
			},
			onAgreePrivacyTerms: (data) => {
				vtoBox.classList.remove("change-height");
				vtoBoxProduct.classList.remove("hide");
				vtoBoxHeadingTerms.classList.add("hide");
				onIssue();
				// vtoBoxHeading.classList.remove("hide");
				console.log(data);
			},
			onDisagreePrivacyTerms: () => {
				vtoBox.classList.remove("change-height");
				vtoBoxProduct.classList.remove("hide");
				vtoBoxHeadingTerms.classList.add("hide");
				// vtoBoxHeading.classList.remove("hide");
				destroyModal("vto-modal");
				destroyVtoModal();
			},
			onLiveStatus: onLiveStatus,
			onIssue: onIssue,
		};
		vtoModal.fitMixInstance = FitMix.createWidget("vto", params, () => {
			if (sku) vtoModal.fitMixInstance.setFrame(sku);
			if (antiReflection)
				vtoModal.fitMixInstance.setLensesAntireflection(antiReflection);
		});
		vtoModal.setAttribute("data-fitmix-ready", "true");
	}

	function onLiveStatus(data) {
		vtoModal.fitMixInstance.startVto(`live`);
		// console.log(data.hasStream);
	}

	function onIssue(data) {
		console.log(data);
	}

	function genderSelectionEvent(e) {
		if (vtoModal.getAttribute("data-vto-setup") === false) {
			console.log("true");
		}

		const gender = this.getAttribute("data-vto-gender");
		if (gender) vtoModal.fitMixInstance.setUserInfo({ gender });
		// Hide overlay:
		vtoModal.fitMixInstance.startVto(`live`);
		vtoModal.setAttribute("data-vto-setup", "false");
	}

	function consentSelectionEvent(e) {
		if (e.target.dataset.vtoConsentMj === "disagree") {
			destroyModal("vto-modal");
			destroyVtoModal();
		}

		const gender = this.getAttribute("data-vto-consent-mj");
		// if (gender) vtoModal.fitMixInstance.setUserInfo({ gender });
		// Hide overlay:
		vtoModal.setAttribute("data-vto-consent-mj-visibility", "false");
	}

	function getStyleData(productCode) {
		const existingData = window.mjpl.vto.styles[productCode];
		// If we’ve already fetched this style, use that data. Otherwise, fetch it.
		if (existingData) {
			return Promise.resolve(existingData);
		} else {
			return fetch(urlEndpointTemplate.replace("$BASE_PRODUCT_CODE", productCode))
				.then((response) => response.json())
				.then((data) => {
					window.mjpl.vto.styles[data.baseProductCode] = data;
					return data;
				});
		}
	}

	function initStyleControls(data, selectedSku) {
		productNameElement.innerHTML = data.styleName;
		createSkuSwatches(data, selectedSku);
	}

	function setFrame(sku) {
		vtoModal.fitMixInstance.setFrame(sku);
	}

	function createSkuSwatch(data, selected) {
		const li = document.createElement("li");
		const inputRadio = document.createElement("input");
		const label = document.createElement("label");
		const span = document.createElement("span");
		const text = document.createTextNode(data.skuName);
		const img = document.createElement("img");

		inputRadio.classList.add("swatch");
		inputRadio.classList.add("radio");
		inputRadio.setAttribute("type", "radio");
		inputRadio.setAttribute("value", data.sku);
		inputRadio.setAttribute("data-vto-sku", data.sku);
		inputRadio.setAttribute("id", `vto-swatch-${data.sku}`);
		inputRadio.setAttribute("data-vto-sku-name", data.skuName);
		inputRadio.setAttribute("data-vto-sku-name-lens", data.lensColor);
		inputRadio.setAttribute("name", "vto-swatch");
		inputRadio.addEventListener("change", changeSwatch);
		inputRadio.checked = selected;

		img.classList.add("radio__image");
		img.setAttribute("src", data.swatchImage);
		img.setAttribute("alt", "");

		span.classList.add("radio__label-text");
		span.appendChild(text);

		label.appendChild(span);
		label.appendChild(img);
		label.setAttribute("for", `vto-swatch-${data.sku}`);

		li.appendChild(inputRadio);
		li.appendChild(label);

		return li;
	}

	function createSkuSwatches(data, selectedSku) {
		console.log(data);
		// Remove existing related styles, in case there are any.
		swatchListContainer.innerHTML = "";

		const firstElement = data.skus[0];
		console.log(firstElement);
		skuNameDisplay.innerHTML = firstElement.skuName || firstElement.sku;
		skuNameDisplayLens.innerHTML = firstElement.lensColor || firstElement.sku;

		vtoModal.allSwatches = data.skus.map((plano) => {
			const selected = plano.sku === selectedSku;
			const swatch = createSkuSwatch(plano, selected);
			swatchListContainer.appendChild(swatch);
			swatchListContainer.setAttribute("data-vto-style-name", data.styleName);
			return swatch;
		});

		vtoModal.currentlyActiveInstance = vtoModal.allSwatches[0].firstElementChild;
		vtoModal.currentlyActiveInstance.defaultChecked = true;
	}

	// function createRelatedStyles(data) {
	// 	// Remove existing related styles, in case there are any.
	// 	relatedStylesListContainer.innerHTML = "";

	// 	data.related.forEach((data) => {
	// 		const li = document.createElement("li");
	// 		const button = document.createElement("button");
	// 		const label = document.createElement("span");
	// 		const img = document.createElement("img");

	// 		label.classList.add("vto__related-style-button-label");
	// 		label.innerText = `${window.vto_i18n.switchToStyle}: ${data.styleName}`;
	// 		button.appendChild(label);
	// 		button.appendChild(img);
	// 		button.setAttribute("type", "button");
	// 		button.setAttribute("data-vto-sku", data.sku);
	// 		button.setAttribute("aria-selected", "false");
	// 		button.setAttribute("data-vto-style", data.baseProductCode);
	// 		button.setAttribute("data-vto-style-name", data.styleName);
	// 		button.setAttribute("data-vto-sku-name", data.skuName);
	// 		button.setAttribute("data-vto-url", data.url);
	// 		button.classList.add("vto__related-style-button");
	// 		button.addEventListener("click", changeStyle);

	// 		li.appendChild(button);
	// 		li.classList.add("vto-related-item");

	// 		img.setAttribute("src", data.productImage);

	// 		relatedStylesListContainer.appendChild(li);
	// 	});
	// }

	function changeSwatch(e) {
		if (
			vtoModal.currentlyActiveInstance.classList.contains(
				"vto__related-style-button"
			)
		) {
			vtoModal.currentlyActiveInstance.setAttribute("aria-selected", "false");
		}

		const swatch = this;
		const sku = swatch.getAttribute("data-vto-sku");
		skuNameDisplay.innerHTML = swatch.getAttribute("data-vto-sku-name") || sku;
		skuNameDisplayLens.innerHTML =
			swatch.getAttribute("data-vto-sku-name-lens") || sku;
		vtoModal.fitMixInstance.setFrame(sku);
		vtoModal.currentlyActiveInstance = swatch;
		productNameElement.innerHTML = swatchListContainer.getAttribute(
			"data-vto-style-name"
		);
	}

	// function changeStyle(e) {
	// 	const button = this;
	// 	const sku = button.getAttribute("data-vto-sku");

	// 	relatedStylesListContainer
	// 		.querySelectorAll('button[aria-selected="true"]')
	// 		.forEach((button) => {
	// 			button.setAttribute("aria-selected", false);
	// 		});

	// 	if (button !== vtoModal.currentlyActiveInstance) {
	// 		button.setAttribute("aria-selected", "true");
	// 		skuNameDisplay.innerHTML = button.getAttribute("data-vto-sku-name") || sku;
	// 		shopThisStyleLink.setAttribute("href", button.getAttribute("data-vto-url"));
	// 		vtoModal.fitMixInstance.setFrame(sku);
	// 		vtoModal.currentlyActiveInstance = button;
	// 		productNameElement.innerHTML = button.getAttribute("data-vto-style-name");
	// 		getStyleData(button.dataset.vtoStyle).then((data) => {
	// 			initStyleControls(data, sku);
	// 			vtoModal.backButton.setAttribute("aria-hidden", false);
	// 		});
	// 	}
	// }

	function instantiateBackButton() {
		const button = vtoModal.querySelector("[data-vto-back-button]");
		const styleName = button.querySelector("[data-vto-back-button-style-name]");
		styleName.innerHTML = `&nbsp;${vtoModal.dataset.vtoDefaultStyleName}`;
		button.addEventListener("click", loadOriginalStyle);
		return button;
	}

	function loadOriginalStyle(event) {
		const sku = vtoModal.dataset.vtoDefaultSku;
		const productCode = vtoModal.dataset.vtoDefaultStyle;
		setFrame(sku);
		getStyleData(productCode).then((data) => {
			initStyleControls(data, sku);
		});
		// shopThisStyleLink.removeAttribute("href");
		// vtoModal.backButton.setAttribute("aria-hidden", true);
		relatedStylesListContainer
			.querySelectorAll('button[aria-selected="true"]')
			.forEach((button) => {
				button.setAttribute("aria-selected", false);
			});
	}

	function destroyVtoModal() {
		if (vtoModal.fitMixInstance) {
			vtoModal.setAttribute("data-fitmix-ready", "false");
			// vtoModal.setAttribute("data-vto-default-sku", "");
			vtoModal.setAttribute("data-vto-default-style", "");
			vtoModal.setAttribute("data-vto-setup", "false");
			vtoModal.fitMixInstance.remove();
			delete vtoModal.fitMixInstance;
			// vtoModal.backButton.setAttribute("aria-hidden", true);
			delete vtoModal.backButton;
			productNameElement.innerHTML = "";
			skuNameDisplay.innerHTML = "";
			skuNameDisplayLens.innerHTML = "";
			// shopThisStyleLink.removeAttribute("href");
		}
	}

	function destroyModal(modalId) {
		console.log(modalId);
		componentEvents.emitEvent("close-modal", [
			{
				id: modalId,
			},
		]);
	}

	function openVtoModal(e) {
		const button = this;
		const defaultSku = button.getAttribute("data-vto-default-sku");
		const productCode = button.getAttribute("data-vto-product-code");
		const antiReflection =
			button.getAttribute("data-vto-anti-reflection") === "true";
		createFitMixInstance(defaultSku, antiReflection);
		vtoModal.setAttribute("data-vto-default-sku", defaultSku);
		vtoModal.setAttribute("data-vto-default-style", productCode);
		componentEvents.emitEvent("open-modal", [{ id: "vto-modal" }]);
		getStyleData(productCode).then((data) => {
			initStyleControls(data, defaultSku);
			// createRelatedStyles(data);
			vtoModal.dataset.vtoDefaultStyleName = data.styleName;
			// vtoModal.backButton = instantiateBackButton();
		});
	}

	function openMobileDrawer() {
		if (vtoModal.getAttribute("data-vto-drawer-toggle") === "false") {
			vtoModal.setAttribute("data-vto-drawer-toggle", "true");
		} else {
			vtoModal.setAttribute("data-vto-drawer-toggle", "false");
		}
	}

	function updateVtoTriggerData(data) {
		if (!data.sku) return;
		const vtoTriggers = Array.from(
			document.querySelectorAll("[data-vto-product-code]")
		);
		vtoTriggers.forEach((trigger) => {
			trigger.dataset.vtoDefaultSku = data.sku;
			trigger.setAttribute("aria-hidden", !data.vtoEnabled);
		});
	}

	if (vtoMobileDrawer) {
		vtoMobileDrawer.addEventListener("click", openMobileDrawer, false);
		vtoMobileDrawer.addEventListener("touchstart", openMobileDrawer, false);
	}

	componentEvents.on("modal-change", (params) => {
		if (params.id === "vto-modal" && params.action === "close") {
			destroyVtoModal();
		}
	});

	// Re-instantiate VTO triggers
	componentEvents.on("component-init", instantiateVtoTriggers);

	// If we’re on PDP, add listener for custom product-data-updated event.
	if (document.querySelector(".product-viewer")) {
		componentEvents.on("product-data-updated", updateVtoTriggerData);
	}
})(window);
